module.exports = __webpack_public_path__ + "static/cb-zasada-dzialania-83daf23eba0cb2ebdb0fdc48b4e19ea9.jpg";